import { Injectable } from '@angular/core';
import { Span } from '@opentelemetry/api';
import { NoopSpan } from './noop-span';
import { ObservabilityService } from './observability-service';
import { TableType } from '@mode/shared/contract-common';

enum SCHEMA_BROWSER_USE_CASES {
  loading_data_source = 'loading_data_source',
  listing_first_page_of_tables = 'listing_first_page_of_tables',
  previewing_a_table = 'previewing_a_table',
}

@Injectable({
  providedIn: 'root',
})
export class SchemaBrowserObservabilityService {
  public static UseCases = SCHEMA_BROWSER_USE_CASES;

  private spans: { [key in SCHEMA_BROWSER_USE_CASES]: Span } = {
    loading_data_source: new NoopSpan(),
    listing_first_page_of_tables: new NoopSpan(),
    previewing_a_table: new NoopSpan(),
  };

  constructor(private observabilityService: ObservabilityService) {}

  public startTrace(useCase: Exclude<SCHEMA_BROWSER_USE_CASES, SCHEMA_BROWSER_USE_CASES.previewing_a_table>): void {
    this.spans[useCase] = this.observabilityService.startTrace(`mode.webapp_ui.schema_browser.${useCase}`);
  }

  public tracePreviewingATable(tableType: string): void {
    this.spans[SCHEMA_BROWSER_USE_CASES.previewing_a_table] = this.observabilityService.startTrace(
      `mode.webapp_ui.schema_browser.${SCHEMA_BROWSER_USE_CASES.previewing_a_table}`,
      {
        attributes: {
          [`mode.webapp_ui.schema_browser.${SCHEMA_BROWSER_USE_CASES.previewing_a_table}.table_type`]: tableType,
        },
      }
    );
  }

  public endTrace(useCase: SCHEMA_BROWSER_USE_CASES): void {
    this.spans[useCase].end();

    this.resetSpan(useCase);
  }

  private resetSpan(useCase: SCHEMA_BROWSER_USE_CASES) {
    this.spans[useCase] = new NoopSpan();
  }
}
